import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { apiClient } from '../api';

export type OnboardingPhase =
  | 'idle'
  | 'home'
  | 'preparation'
  | 'results'
  | 'speech'
  | 'practice'
  | 'ideas'
  | 'completed'
  | 'skipped';

interface OnboardingState {
  phase: OnboardingPhase;
  completed: boolean;
  skipped: boolean;
  setPhase: (phase: OnboardingPhase) => void;
  complete: () => void;
  skip: () => void;
  restart: () => void;
  syncToBackend: () => Promise<void>;
}

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    set => ({
      phase: 'idle',
      completed: false,
      skipped: false,

      setPhase: phase => set({ phase }),

      complete: () =>
        set({
          phase: 'completed',
          completed: true,
        }),

      skip: () =>
        set({
          phase: 'skipped',
          skipped: true,
        }),

      restart: () =>
        set({
          phase: 'idle',
          completed: false,
          skipped: false,
        }),

      syncToBackend: async () => {
        try {
          await apiClient.post('/v2/set-onboarding-complete', {});
        } catch (error) {
          console.error('Failed to sync onboarding status to backend:', error);
        }
      },
    }),
    {
      name: 'speechai-onboarding',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
